import { FormControl, Validators } from '@angular/forms';
import { EoCheckboxConfig, EoFormPanelConfig, EoInputConfig, EoMultiselectConfig } from 'ngx-eo-web-components';
import { rolesForDialog } from '../../shared/components/role-dropdown/role-dropdown.config';

export const header = 'Διαχείριση Χρηστών';

export function buildUserFormConfig(onRoleRemove: (e: any) => void): EoFormPanelConfig[] {

  const userFormPanel = new EoFormPanelConfig({
    name: 'user',
    panelContentStyleClass: 'grid',
    config: [
      new EoInputConfig({
        name: 'userName',
        styleClass: 'col-12 md:col-6',
        type: 'text',
        label: 'Username',
        control: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9@_]{1,30}$/)]),
        placeholder: 'Παρακαλώ συμπληρώστε το username του χρήστη',
        inputIcon: 'pi pi-user',
        errors: {
          pattern: 'Το όνομα χρήστη πρέπει να περιέχει μόνο λατινικούς χαρακτήρες, αριθμούς, @ ή _ και να έχει μήκος έως 30 χαρακτήρες'
        }
      }),
      new EoInputConfig({
        name: 'email',
        styleClass: 'col-12 md:col-6',
        type: 'email',
        label: 'Email',
        placeholder: 'Παρακαλώ συμπληρώστε το email του χρήστη',
        control: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/)]),
        inputIcon: 'pi pi-envelope',
      }),
      new EoInputConfig({
        name: 'name',
        styleClass: 'col-12 md:col-6',
        type: 'text',
        label: 'Όνομα',
        placeholder: 'Παρακαλώ συμπληρώστε το όνομα του χρήστη',
        control: new FormControl('', [Validators.required]),
      }),
      new EoInputConfig({
        name: 'surname',
        styleClass: 'col-12 md:col-6',
        type: 'text',
        label: 'Επώνυμο',
        placeholder: 'Παρακαλώ συμπληρώστε το επώνυμο του χρήστη',
        control: new FormControl('', [Validators.required]),
      }),
      new EoMultiselectConfig({
        name: 'roles',
        label: 'Ρόλος',
        placeholder: 'Επιλέξτε ένα ρόλο',
        styleClass: 'col-12 md:col-6',
        showClear: true,
        options: rolesForDialog,
        optionLabel: 'label',
        optionValue: 'value',
        appendTo: 'body',
        onRemove: onRoleRemove,
        control: new FormControl(null, [Validators.required]),
      }),
      new EoCheckboxConfig({
        name: 'lockoutEnabled',
        styleClass: 'col-6 flex flex-column justify-content-center',
        label: 'Κλειδωμένος',
        control: new FormControl(null),
      }),
    ],
  });

    return [userFormPanel];
}
